import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';

/**
 * Full-viewport modal shell portaled to document.body so overlays cover the
 * fixed header (and are not clipped by layout overflow / containing blocks).
 */
const ModalShell = ({
  isOpen,
  onClose,
  children,
  className = '',
  panelClassName = '',
  labelledBy,
}) => {
  useEffect(() => {
    if (!isOpen) return undefined;
    const previous = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    const onKey = (e) => {
      if (e.key === 'Escape') onClose?.();
    };
    document.addEventListener('keydown', onKey);
    return () => {
      document.body.style.overflow = previous;
      document.removeEventListener('keydown', onKey);
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return createPortal(
    <div
      className={`fixed inset-0 z-[11000] flex items-center justify-center p-4 sm:p-6 ${className}`}
      role="dialog"
      aria-modal="true"
      aria-labelledby={labelledBy}
    >
      <div
        className="absolute inset-0 bg-black/55 dark:bg-black/70"
        onClick={onClose}
        aria-hidden="true"
      />
      <div className={`relative z-10 w-full max-h-[min(90vh,900px)] overflow-y-auto ${panelClassName}`}>
        {children}
      </div>
    </div>,
    document.body
  );
};

export default ModalShell;
